import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <span className="text-foreground-300" aria-hidden="true">/</span>
            )}
            {isLast || !item.href ? (
              <span className={isLast ? 'text-foreground-700 font-medium' : ''}>{item.label}</span>
            ) : (
              <Link to={item.href} className="hover:text-primary-600 transition-colors duration-200">
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}